import { Card, Typography, Container, Button } from "@mui/material";
import NotificationActionButton from "./NotificationActionButton";
import AccessibilityIcon from "@mui/icons-material/Accessibility"
/**
 *  Notification card
 * @param {*} param0
 * @returns
 */

function NotificationCard({
    id,
    backgroundColor,
    textColor,
    title,
    textOne,
    textTwo,
    startTarget,
    onRemindLaterClick,
    handleStartClick
}) {

    return (
        <Card
            id={id}
            sx={{
                backgroundColor: `${backgroundColor}`,
                color: `${textColor}`,
                borderRadius: 0,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)"
            }}
        >
            <Container sx={{ textAlign: "center", pt: 2, mt: 2, mb: -4 }}><AccessibilityIcon style={{ justifyContent: "center", alignItems: "center" }} sx={{ color: "primary.main", fontSize: 50, alignContent: "center" }} align="center">
            </AccessibilityIcon></Container>

            
                <Typography
                    sx={{
                        fontWeight: "bold",
                        fontSize: 25,
                        ml: 2,
                        mt: 5,
                        pt: 1.2,
                        flexGrow: 1,
                    }}
                    align="center"
                >
                    {title}
                </Typography>
            {
                <Typography
                    sx={{
                        fontSize: 16,
                        mt: 2,
                        mx: 2,
                    }}
                    align="center"
                >
                    {textOne}
                </Typography>
            }
            {<Typography sx={{
                fontStyle: 'italic',
                fontSize: 13,
                mt: 1,
                mx: 2,
            }} align="center">{textTwo}</Typography>}
            <Container sx={{ textAlign: "center", pt: 2, pb: 3, mt: 2 }}>
                <NotificationActionButton
                    id='start-accessibility-btn'
                    buttonColor='primary.dark'
                    buttonTextColor='primary.contrastText'
                    buttonTitle='Start'
                    hoverColor='primary.light'
                    hoverTextColor='primary.dark'
                    target={startTarget}
                    width={{ xs: "12em", lg: "16em" }}
                    onClick={handleStartClick}
                />
            </Container>
            <Container sx={{ textAlign: "right", pb: 3 }}>
                <Button
                    id='remind-me-later-btn'
                    onClick={onRemindLaterClick}
                    variant='outlined'
                    sx={{
                        m: 2,
                        textTransform: "none",
                        borderRadius: 0,
                        width: { xs: "12em", lg: "16em" },
                        "&:hover": {
                            backgroundColor: "primary.light",
                        },
                    }}
                >
                    Remind me later...
                </Button>
            </Container>
        </Card >
    );
}

export default NotificationCard;